<template>
  <div>
    <NavbarOne />

    <div
      class="flex items-center gap-4 flex-wrap bg-overlay p-14 sm:p-16 before:bg-title before:bg-opacity-70"
      :style="{ backgroundImage: 'url(' + bg + ')' }"
    >
      <div class="text-center w-full">
        <h2 class="text-white text-8 md:text-[40px] font-normal leading-none text-center">
          Shop
        </h2>
        <ul
          class="flex items-center justify-center gap-[10px] text-base md:text-lg leading-none font-normal text-white mt-3 md:mt-4"
        >
          <li><router-link to="/">Home</router-link></li>
          <li>/</li>
          <li class="text-primary">Shop</li>
        </ul>
      </div>
    </div>
    <div class="s-py-100">
      <div class="container-fluid">
        <div
          class="flex items-start justify-between gap-8 max-w-[1720px] mx-auto flex-col lg:flex-row border-b border-bdr-clr dark:border-bdr-clr-drk pb-8 md:pb-[50px]"
        >
          <div>
            <h4 class="font-medium leading-none text-xl sm:text-2xl mb-5 sm:mb-6">
              Choose Category
            </h4>
            <div class="flex flex-wrap gap-[10px] md:gap-[15px]">
              <!-- Tambah button "All Products" -->
              <button
                @click="showAllProducts"
                class="btn btn-theme-outline btn-sm shop1-button"
                :class="{ active: selectedCategory === '' }"
                data-text="All Products"
              >
                <span>All Products</span>
              </button>

              <button
                v-for="(item, index) in categoryOne"
                :key="index"
                @click="filterByCategory(item.slug)"
                class="btn btn-theme-outline btn-sm shop1-button"
                :class="{ active: selectedCategory === item.slug }"
                :data-text="item.name"
              >
                <span>{{ item.name }}</span>
              </button>
            </div>
          </div>
        </div>

        <div data-aos="fade-up" data-aos-delay="200">
          <LayoutOne
            :classList="'max-w-[1720px] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-8 pt-8 md:pt-[50px]'"
            :productList="filteredProducts"
          />
        </div>

        <div v-if="filteredProducts.length === 0" class="text-center mt-8">
          <p class="text-lg text-gray-600">No products found in this category.</p>
        </div>

        <div v-if="showLoadMore" class="text-center mt-7 md:mt-12">
          <button @click="loadMore" class="btn btn-outline" data-text="Load More">
            <span>Load More</span>
          </button>
        </div>
      </div>
    </div>

    <FooterOne />
    <ScrollToTop />
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import NavbarOne from "@/components/navbar/navbar-one.vue";
import LayoutOne from "@/components/product/layout-one.vue";
import FooterOne from "@/components/footer/footer-six.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";
import bg from "@/assets/img/shortcode/breadcumb.jpg";
import { productList, categoryOne } from "@/data/data";
import Aos from "aos";

// State
const selectedCategory = ref("");
const itemsPerPage = ref(8);
const currentPage = ref(1);

// Computed properties
const filteredProducts = computed(() => {
  let products;

  if (selectedCategory.value) {
    // Filter produk berdasarkan kategori yang dipilih
    const categoryProducts = productList.filter(
      (product) => product.categorySlug === selectedCategory.value
    );

    // Hilangkan duplikat berdasarkan nama
    products = categoryProducts.reduce((acc, product) => {
      if (!acc.find((p) => p.name === product.name)) {
        acc.push({
          ...product,
          variants: categoryProducts.filter((p) => p.name === product.name),
        });
      }
      return acc;
    }, []);
  } else {
    // Untuk "All Products", tampilkan semua produk tanpa duplikasi
    products = productList.reduce((acc, product) => {
      if (!acc.find((p) => p.name === product.name)) {
        acc.push({
          ...product,
          variants: productList.filter((p) => p.name === product.name),
        });
      }
      return acc;
    }, []);
  }

  return products.slice(0, itemsPerPage.value * currentPage.value);
});

const showLoadMore = computed(() => {
  let totalProducts;

  if (selectedCategory.value) {
    // Hitung jumlah produk unik dalam kategori
    const uniqueProducts = new Set(
      productList
        .filter((product) => product.categorySlug === selectedCategory.value)
        .map((product) => product.name)
    );
    totalProducts = uniqueProducts.size;
  } else {
    // Untuk "All Products", hitung jumlah total produk unik
    const uniqueProducts = new Set(productList.map((product) => product.name));
    totalProducts = uniqueProducts.size;
  }

  return totalProducts > itemsPerPage.value * currentPage.value;
});

// Methods
const filterByCategory = (category) => {
  selectedCategory.value = category;
  currentPage.value = 1;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const showAllProducts = () => {
  selectedCategory.value = "";
  currentPage.value = 1;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const loadMore = () => {
  currentPage.value += 1;
};

onMounted(() => {
  Aos.init();
  showAllProducts();
});
</script>

<style scoped>
.btn.active {
  background-color: var(--primary-color);
  color: white;
}
</style>
